/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Proof_GatewayInputs */

const en_cap_proof_gateway = /** @type {(inputs: Cap_Proof_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI gateway`)
};

const lv_cap_proof_gateway = /** @type {(inputs: Cap_Proof_GatewayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI vārteja`)
};

/**
* | output |
* | --- |
* | "AI gateway" |
*
* @param {Cap_Proof_GatewayInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_proof_gateway = /** @type {((inputs?: Cap_Proof_GatewayInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Proof_GatewayInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_proof_gateway(inputs)
	return en_cap_proof_gateway(inputs)
});